import { post, get, patch, deleteRequest } from "./restApi";

export const getInstallationOrderHistories = (payload) => {
    return patch("installation-order-history/get-list", payload);
}
